import { ComponentContent } from "../../types/stocks";
import RecentlyViewedContainer from "./RecentlyViewedContainer";

interface RecentlyViewedProps {
  content?: ComponentContent;
  isMobileApp?: boolean;
}

export const RecentlyViewed = ({
  content,
  isMobileApp,
}: RecentlyViewedProps) => (
  <RecentlyViewedContainer content={content} isMobileApp={isMobileApp} />
);

export default RecentlyViewed;
